import $ from 'jquery';
import cookie from 'jquery.cookie';

export default function popup() {

  function showOverlay() {
		$('body').addClass('block-site');
		// var maskWidth = $(window).width();
		var maskHeight = $(document).height();
		$('#mask').css({'height':maskHeight});
		//effetto overlay
		$('#mask').fadeIn(1000);        
		$('#mask').fadeTo("slow",0.8);  
		//hrecupero altezza e larghezza della finestra
		var winH = $(window).height();
		// var winW = $(window).width();
		var scrolltop = $(window).scrollTop();
		var alto = (winH - 400) / 2;
		// var difference = scrolltop + alto;
		//imposto al centro della finestra la "popup"
		//$('#dialog').css('top', difference);
		//$('#dialog').css('left', winW/2-$('#dialog').width()/2);
		//effetto overlay
		$('#dialog').fadeIn(2000);
	}
  
  function init() {
    var url = window.location.href;
		var lastPart = url.substr(url.lastIndexOf('/') + 1);
		
    //MOSTRO IL POPUP SE NON HO IL COOKIE SETTATO
		if (lastPart === "home.html" || lastPart === "index.html") {
			if ($.cookie('bcp-popup-overlay') == null) {
				showOverlay();
			}
		}
    
    //CHIUDO IL POPUP
    $('.window').on('click', '.close-dialog', function (e) {
      e.preventDefault();
      $('body').removeClass('block-site');
      $('#mask').hide();
      $('.window').hide();
      
      $.cookie('bcp-popup-overlay', 'hide', { path: '/', secure: false, domain: '' });
    });
    
    //CLICCO NEI LINK DEL POPUP
    $('#article-popup').on('click', '.link-popup', function () {
      $('body').removeClass('block-site');
      $.cookie('bcp-popup-overlay', 'hide', { path: '/', secure: false, domain: '' });
    });
  }
  
  $( document ).ready(function() {
    if($('#article-popup').length > 0) {
      init();
    }
  });
  
}